import { SplitText as SplitTextGSAP } from 'gsap/SplitText';

export default class SplitText extends HTMLElement {
  constructor() {
    super();
    // UI

    // Config

    // Data
    this.target = this.querySelector('[data-split-text]')
      ? this.querySelector('[data-split-text]')
      : this.children[0];

    this.type = this.dataset?.type ? this.dataset.type : 'lines';
  }

  // =============================================================================
  // Lifecycle methods
  // =============================================================================
  connectedCallback() {
    this.bindEvents();
  }

  disconnectedCallback() {
    this.unbindEvents();
  }

  // =============================================================================
  // Events
  // =============================================================================
  bindEvents() {
    this.splitText = SplitTextGSAP.create(this.target, {
      type: 'lines',
      mask: 'lines',
      linesClass: 'c-split_line',
      // wordsClass: 'c-split_word',
      // charsClass: 'c-split_char',
      autoSplit: true,
      smartWrap: true,

      onSplit: self => {
        this.split(self);
      }
    });
  }

  split(self) {
    this.style.setProperty('--lines-count', self.lines.length);
    this.style.setProperty('--words-count', self.words.length);
    this.style.setProperty('--chars-count', self.chars.length);

    self.lines.forEach((line, index) => {
      line.style.setProperty('--line-index', index);
    });
    self.words.forEach((word, index) => {
      word.style.setProperty('--word-index', index);
    });
    self.chars.forEach((char, index) => {
      char.style.setProperty('--char-index', index);
    });
  }

  unbindEvents() {
    // При размонтировании (переход на другую страницу) не вызываем revert() —
    // он меняет DOM в момент замены контента Swup и текст пропадает.
    // Только очищаем инстанс через kill().
    if (this.splitText) {
      this.splitText.kill?.();
      this.splitText = null;
    }
  }

  ///////////////
  // Methods
  ///////////////

  // Склеивает текст обратно в исходное состояние
  revert() {
    if (this.splitText) {
      this.splitText.revert();
      this.splitText = null;
    }
  }
}
